export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13122.63e750e8.jpg";